/**
 * A function that returns an array with a sequence of numbers from 0 to stop.
 * This is based off of Python's range() function.
 * @function range
 * @param {number} start If only this param is specified, it determines at which position to stop (non-inclusive), otherwise it's the position to start (inclusive).
 * @param {number} stop An integer specifying at which position to stop (non-inclusive).
 * @param {number} [step=1] A number used as the increment between elements in the sequence.
 * @returns {Array<Integer>}
 */
export default function range(start, stop, step = 1) {
    const stopGiven = !isNaN(stop);
    const computedStart = stopGiven ? start : 0;
    const computedStop = stopGiven ? stop : start;

    if ([computedStart, computedStop, step].some(input => !Number.isInteger(input))) {
        throw new Error('range() supports only integer inputs.');
    }

    const infiniteUp = step > 0 && computedStart >= computedStop;
    const infiniteDown = step < 0 && computedStart <= computedStop;
    const infinite = infiniteUp || infiniteDown || step === 0;
    const result = [];

    if (!infinite) {
        for (let iter = computedStart; step > 0 ? iter < computedStop : iter > computedStop; iter += step) {
            result.push(iter);
        }
    }

    return result;
}
